import styled from "@emotion/styled";

import { StoryStyleLargeLayout } from "~/components/story-style/story-style-large-layout";
import { StoryStyleLayout } from "~/components/story-style/story-style-layout";

export const StyledStoryStyleLargeLayout = styled(StoryStyleLargeLayout)`
  display: none;
  ${props => props.theme.breakpoints.up("mediumDesktop")} {
    display: flex;
  }
`;

export const StyledStoryStyleLayout = styled(StoryStyleLayout)`
  display: block;
  ${props => props.theme.breakpoints.up("mediumDesktop")} {
    display: none;
  }
`;
